import { render, staticRenderFns } from "./gtexPage.vue?vue&type=template&id=0e72dfdc&"
import script from "./gtexPage.vue?vue&type=script&lang=js&"
export * from "./gtexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports